import { useEffect, useState } from "react";
import BiaxialBarChart from "./BiaxialBarChart";

const PivotableBiaxialBarChart = ({
  title,
  usages,
  groupBy,
  countBys = [
    { name: "gwp", axis: "left", label: "GWP" },
    { name: "cost", axis: "right", label: "Cost" },
  ],
}) => {
  //   const { t } = useTranslation();
  const [data, setData] = useState([]);
  useEffect(() => {
    const grouped = {};

    usages.forEach((u) => {
      const key = `${u[groupBy]}`;
      countBys.forEach((c) => {
        if (!grouped[key]) grouped[key] = {};
        if (!grouped[key][c.name]) grouped[key] = { ...grouped[key], [c.name]: 0 };
        grouped[key][c.name] += u[c.name];
      });
    });
    const chartData = Object.entries(grouped)
      .map(([name, value]) => ({ [groupBy]: name, ...value }))
      .sort((a, b) => b[countBys[0].name] - a[countBys[0].name]);

    setData(chartData);
  }, [usages]);
  return <BiaxialBarChart title={title} data={data} name={groupBy} fields={countBys} />;
};

export default PivotableBiaxialBarChart;
